const styles = theme => ({
    grow: {
        flexGrow: 1
    },

    toolbar: {
      borderBottom: `1px solid rgba(0, 0, 0, 0.12)`
    },
  
    menuButton: {
      marginLeft: -12
    },
    wrapper: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: theme.spacing(3),
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        minHeight: '70vh'
    }
  })
  
  export default styles
  